export default __webpack_public_path__ + "images/52490d04f11d74e3c2dc4a9457920b46-metal_music.webp";